var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122779",
    "data-name": "Group 122779",
    transform: "translate(-305 -247)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(305 247)",
    fill: "#8a9123"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-stopwatch",
    "data-name": "Icon ionic-md-stopwatch",
    transform: "translate(307.51 250.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20323",
    "data-name": "Path 20323",
    d: "M16.313,17.132H18.06V12.375H16.313Z",
    transform: "translate(-5.697 -4.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_122962",
    "data-name": "Group 122962",
    transform: "translate(4.5 2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20324",
    "data-name": "Path 20324",
    d: "M17.01,9.454l1.121-1.121L16.9,7.1,15.775,8.218A6.989,6.989,0,1,0,17.01,9.454ZM15.35,17.6a5.46,5.46,0,1,1,1.6-3.861A5.425,5.425,0,0,1,15.35,17.6Z",
    transform: "translate(-4.5 -4.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20325",
    "data-name": "Path 20325",
    d: "M13.5,2.25h4.66V4H13.5Z",
    transform: "translate(-8.84 -2.25)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/timeIcon.48c89459472585f632cc962445d0e035.svg";
export { ForwardRef as ReactComponent };